import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Rating as RatingComponent } from '@fiverr-private/orca';

import './styles.scss';

export const COLORS = RatingComponent.COLORS;
export const THEMES = {
    DYNAMIC: 'DYNAMIC',
    FIVE_STARS: RatingComponent.THEMES.FIVE_STARS,
    ONE_STAR: RatingComponent.THEMES.ONE_STAR,
};

/**
 * @param {number} ratingsCount - number of reviewers
 * @param {number} score - review's average score between 1-5
 * @param {string} theme - one of THEMES const,
 * @param {Object} props - Orca's Rating component props
 * @returns {JSX.Element} - orca's rating component with 1|5|dynamic stars
 **/
const Rating = ({ score = 0, ratingsCount = 0, theme = THEMES.FIVE_STARS, className = '', ...props }) => {
    const { THEMES: STARS_THEMES } = RatingComponent;
    const ratingStars = {
        color: RatingComponent.COLORS.BLACK,
    };

    return theme === THEMES.DYNAMIC ? (
        <>
            <RatingComponent
                {...ratingStars}
                {...props}
                score={score}
                ratingsCount={ratingsCount}
                theme={STARS_THEMES.FIVE_STARS}
                className={classnames(className, 'ratings-header', 'rating-desktop')}
            />
            <RatingComponent
                {...ratingStars}
                {...props}
                score={score}
                ratingsCount={ratingsCount}
                theme={STARS_THEMES.ONE_STAR}
                className={classnames(className, 'ratings-header', 'rating-mobile')}
            />
        </>
    ) : (
        <RatingComponent
            {...ratingStars}
            {...props}
            score={score}
            ratingsCount={ratingsCount}
            className={className}
            theme={theme}
        />
    );
};

Rating.propTypes = {
    score: PropTypes.number.isRequired,
    ratingsCount: PropTypes.number,
    theme: PropTypes.string,
    className: PropTypes.string,
};

export default Rating;
